import React from "react";
import { Outlet } from "react-router";
import NavbarExternal from "../components/navbar-external";

import useRealViewportHeight from "../hooks/use-real-viewport-height";

const ExternalLayout = () => {
  useRealViewportHeight();

  return (
    <div id="wrapper">
      <div id="content-wrapper">
        <NavbarExternal />
        <div className="page-wrapper-external">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ExternalLayout;
